export const MATERIAL_TYPES = {
  FORUM_POST: 1,
  QUESTION: 4,
};
